export enum TipoVisualizacao{
    Mes = 1, Semana = 2, Dia = 3
}
